import { apiSlice } from "app/api/apiSlice"


export const healtDataApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // HR
        getUserHrData: builder.query({
            query: ({ userGuid, start, end }) => {
                return {
                    url: 'health/data/hr',
                    method: 'GET',
                    params: {
                        userGuid: userGuid,
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        }),
        // SP02
        getUserSp02Data: builder.query({
            query: ({ userGuid, start, end }) => {
                return {
                    url: 'health/data/sp02',
                    method: 'GET',
                    params: {
                        userGuid: userGuid,
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        }),
        // TEMPS
        getUserTempsData: builder.query({
            query: ({ userGuid, start, end }) => {
                return {
                    url: 'health/data/temp',
                    method: 'GET',
                    params: {
                        userGuid: userGuid,
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        }),
        // BLOOD PRESSURE
        getUserBloodPressureData: builder.query({
            query: ({ userGuid, start, end }) => {
                return {
                    url: 'health/data/bloodPressure',
                    method: 'GET',
                    params: {
                        userGuid: userGuid,
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        }),
        // STEPS
        getUserStepsData: builder.query({
            query: ({ userGuid, start, end }) => {
                return {
                    url: 'health/data/steps',
                    method: 'GET',
                    params: {
                        userGuid: userGuid,
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        }),
        // vO2Max
        getUserVO2MaxData: builder.query({
            query: ({ userGuid, start, end }) => {
                return {
                    url: 'health/data/vO2Max',
                    method: 'GET',
                    params: {
                        userGuid: userGuid,
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        }),
        // BIA
        getUserBiaData: builder.query({
            query: ({ userGuid, start, end }) => {
                return {
                    url: 'health/data/bia',
                    method: 'GET',
                    params: {
                        userGuid: userGuid,
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        }),
        // ECG
        getUserECGData: builder.query({
            query: ({ userGuid, start, end }) => {
                return {
                    url: 'health/data/ecg',
                    method: 'GET',
                    params: {
                        userGuid: userGuid,
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        }),
        // ECG List
        getUserECGList: builder.query({
            query: ({ userGuid, start, end }) => {
                return {
                    url: 'health/data/ecg/list',
                    method: 'GET',
                    params: {
                        userGuid: userGuid,
                        start: start,
                        end: end
                    }
                }
            },
            keepUnusedDataFor: 5,
        })
    })
})

export const {
    useLazyGetUserHrDataQuery,
    useLazyGetUserSp02DataQuery,
    useLazyGetUserTempsDataQuery,
    useLazyGetUserBloodPressureDataQuery,
    useLazyGetUserStepsDataQuery,
    useLazyGetUserVO2MaxDataQuery,
    useLazyGetUserBiaDataQuery,
    useLazyGetUserECGDataQuery,
    useLazyGetUserECGListQuery
} = healtDataApiSlice